module.exports = __webpack_public_path__ + "img/Welcome1.5f4a270b.png";